<template>
  <div class="page-wrapper">
    <search-group title="" @search="findData" @clear="clearValue" :span="24" :btnOffset="20" :btnSpan="6"
                  :multipleLines="false" :inline="true"
                  style="padding: 0"
    >
      <Row class="mb16" :gutter="16">
<!--        <Col span="5">-->
<!--          <Select v-model="searchData.oneCategoryName"  placeholder="资产一级分类" @on-change="getTwo">-->
<!--            <Option value=''>请选择</Option>-->
<!--            <Option v-for="(item,index) in oneCategoryListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>-->
<!--          </Select>-->
<!--        </Col>-->
<!--        <Col span="5">-->
<!--          <Select v-model="searchData.twoCategoryName" placeholder="资产二级分类">-->
<!--            <Option value=''>请选择</Option>-->
<!--            <Option v-for="(item,index) in twoCategoryListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>-->
<!--          </Select>-->
<!--        </Col>-->
        <Col span="5">
          <Input placeholder="资产编号" v-model="searchData.assetsCode"></Input>
        </Col>
        <Col span="5">
          <Input placeholder="资产名称" v-model="searchData.assetsName"></Input>
        </Col>
        <Col span="6">
         <DatePicker type="datetimerange" style="width:100%" split-panels v-model="putTime" format="yyyy-MM-dd" placeholder="入库时间"></DatePicker>
        </Col>
      </Row>
    </search-group>

    <div >
      <Button  type="primary" @click.stop="add" class="mb16">入库</Button>
    </div>

    <assets-add
        :n="addN"
        :pid="pid"
        @done="getData">
    </assets-add>

    <table-list
      class="mt12"
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    ></table-list>

  </div>
</template>

<script type="text/ecmascript-6">
  import SearchGroup from 'components/SearchGroup/index';
  import TableList from 'components/TableList/index';
  import {getAssetsPutRecordList, deleteAssetsInfo} from "../../api/assets";
  import {getCategoryTypeList} from "../../api/assets";
  import {formatDateTime} from "utils/format";
  import AssetsAdd from "@/views/gdMap/assetsAdd";
  export default {
    condition:'advice',
    components: {
      AssetsAdd,
      SearchGroup,
      TableList
    },
    mounted() {
      this.findData()
    },
    computed: {
      searchDataComputed() {
        // if(this.searchData.twoCategoryName){
        //   this.searchData.ifChildType = 1
        //   this.searchData.categoryCode = this.searchData.twoCategoryName
        // } else {
        //   this.searchData.categoryCode = this.searchData.oneCategoryName
        //   this.searchData.ifChildType = 0
        // }
        return {
          // categoryCode:this.searchData.categoryCode,
          assetsName: this.searchData.assetsName,
          assetsCode:this.searchData.assetsCode,
          putTimeFrom:this.putTime[0],
          putTimeTo:this.putTime[1]
          // ifChildType:this.searchData.ifChildType
        }
      }
    },
    watch: {

    },
    data() {
      return {
        infoN:0,
        itemData:null,
        monthList:[],
        searchParams:null,
        data: [],
        addN:0,
        oneCategoryListData:[],
        twoCategoryListData:[],
        putTime:['',''],
        pid:'',
        columns: [
          {
            type: 'index',
            width: 60,
            key:'fid',
            align: 'center',
          },
          {
            title: ' '
          },
          {
            title: '资产编号 ',
            key: 'assetsCode',
            width: 150,
          },

          {
            title: ' '
          },
          {
            title: '资产名称',
            key: 'assetsName',
            width: 130,

          },
          {
            title: ' '
          },
          {
            title: "资产类型",
            key: 'oneCategoryName',
            width: 180,
          },
          {
            title: ' '
          },
          {
            title: "入库数量",
            key: 'putNumber',
            width: 150,
          },
          {
            title: ' '
          },
          {
            title: "入库时间",
            key: 'putTime',
            width: 180,
            render:(h,params)=>{
              return h('span',{},formatDateTime(params.row['putTime'],false))
            }
          },
          {
            title: ' '
          },
          {
            title: "入库人姓名",
            key: 'putPersonName',
            width: 150,
          },
          // {
          //   title: '操作',
          //   align: 'center',
          //   width: 150,
          //   fixed: 'right',
          //   render:(h,params)=>{
          //     return [
          //       h('a', {
          //         on: {
          //           click: () => {
          //             // this.$nextTick( ()=> {
          //               // this.pid=params.row.fid;
          //               // this.addN++;
          //               this.$router.push({path:'/app/assetsUpdate',query:{id:params.row.fid}});
          //             // })
          //           }
          //         },
          //         style: {
          //           marginRight: '10px'
          //         }
          //       }, '编辑信息'),
          //       h('a', {
          //         on: {
          //           click: () => {
          //             this.$router.push({path:'/app/provideAssets',query:{id:params.row.sizeFid}});
          //           }
          //         },
          //         style: {
          //           marginRight: '10px'
          //         }
          //       }, '查看发放记录'),
          //       h('a', {
          //         on: {
          //           click: () => {
          //             this.deleteItem(params.row['fid'])
          //           }
          //         },
          //         style: {
          //           marginRight: '10px',
          //           // display:params.row['stockProvidedNumber']>0?'':'none'
          //         }
          //       }, '删除'),
          //     ]
          //   }
          // }
        ],
        total: 0,
        current: 1,
        loading: false,
        metaList:[],
        page:1,
        limit:10,
        searchData: {
          // oneCategoryName: '',
          // twoCategoryName: '',
          assetsName:'',
          assetsCode:''
          // ifChildType:2,
          // categoryCode:''
        },
      }
    },
    methods: {
      add(){
        this.pid='';
        this.addN++
      },
      getTwo(value){
        if (!value){
          return
        }
        getCategoryTypeList(
            {
              parentCategoryCode:value
            }
        ).then(res => {
          if (!res.data) {
            return
          }
          this.twoCategoryListData = res.data.categoryList
        }).catch(() => {
          return
        })
      },
      getData(){
        const params={
          ...this.searchParams,
          page:this.page,
          limit:this.limit
        }
        getAssetsPutRecordList(params).then(res=>{
          if(!res.data){
            return
          }
          this.total=res.data.total
          this.data=res.data.rows?res.data.rows:[]
        }).catch(error=>{
        })

      },
      changPage(n){
        this.current = n;
        this.page = n;
        this.getData()
      },
      findData() {
        this.searchParams=this.searchDataComputed
        this.page=1
        this.current=1
        this.getData()
      },
      clearValue() {
        this.searchData = {
          areaFid: '',
          assetsName:'',
          assetsCode:''
        }
        this.putTime=['','']
      },
      changeTableRowTextExpandState(i){
        this.data = this.data.map(( item,index ) => {
          if( i === index ){
            item.expandText = !item.expandText
          }
          return item;
        })
      },
      deleteItem(fid){
        this.$Modal.confirm({
          title:'确定删除资产',
          content:'<p>确认删除本条记录？</p>',
          onOk:()=>{
            let params={
              assetsFid:fid
            }
            deleteAssetsInfo(params).then(res=>{
              this.$Message.success('删除成功')
              this.current=1
              this.page=1
              this.getData()
            }).catch(error=>{})
          }
        })
      }
    },
    created() {
      // getCategoryTypeList(
      //     {
      //       parentCategoryCode:-1
      //     }
      // ).then(res => {
      //   if (!res.data) {
      //     return
      //   }
      //   this.oneCategoryListData = res.data.categoryList
      // }).catch(() => {
      //   return
      // })
    }
  }
</script>

<style scoped>
  .width3 {
    width: 200px;
  }
  .wrappertabs{
    min-height: 400px;
  }
</style>
<style>
  .feedback-text-wrapper{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .feedback-text-container > .ivu-table-cell > div{
    padding: 10px 0;
    overflow: hidden;
  }
</style>